import ModelUtil from '@leverege/model-util';
import { GoogleGeoLayerModel } from '@leverege/molten/data-viewers';
const TYPE = 'molten.googleMapRenderer.FilterableZoneGeoShapeModel';

/**
 * This represents geo layers that have point objects. It will contain
 * options for the layer as whole, such as visibility options and selection
 * and rollover options.
 */
function create(layerName, name, objectType, extend) {
  return {
    ...GoogleGeoLayerModel.create(layerName, name, objectType),
    type: TYPE,
    // ToDo: Add Symbol select/style for points geo json
    // ToDo: Add Text style/accessor 
    showAtZoom: 0,
    hideAtZoom: 23,
    lineStyle: {
      color: {
        type: 'colorizer.Value',
        color: '#2F77E4'
      },
      // Colorizer,
      width: 1,
      style: 'default',
      dashArray: null,
      // [ 8, 3 ]
      pattern: null,
      opacity: 1,
      cap: 'round',
      join: 'round'
    },
    fillStyle: {
      color: {
        type: 'colorizer.Value',
        color: '#D0EBFF'
      },
      // Colorizer,
      pattern: null,
      // for image bgs
      opacity: 0.4
    },
    labelStyle: {
      visible: true,
      color: {
        type: 'colorizer.Value',
        color: '#000000'
      },
      // Colorizer,
      pattern: null,
      // for image bgs
      opacity: 1.0,
      attribute: 'name',
      allowOverlap: false,
      ignorePlacement: false,
      size: 16
    },
    rolloverLineStyle: {
      hasColor: false,
      hasWidth: true,
      hasOpacity: false,
      hasDashArray: false,
      hasStyle: false,
      hasPattern: false,
      hasCap: false,
      hasJoin: false,
      color: null,
      // Colorizer,
      width: 3,
      style: 'default',
      dashArray: null,
      // [ 8, 3 ]
      pattern: null,
      opacity: 0.25,
      cap: 'round',
      join: 'round'
    },
    rolloverFillStyle: {
      hasColor: false,
      hasPattern: false,
      hasOpacity: true,
      color: null,
      // Colorizer,
      pattern: null,
      // for image bgs
      opacity: 0.25
    },
    rolloverLabelStyle: {
      hasVisible: false,
      hasColor: false,
      hasOpacity: false,
      hasAttribute: false,
      hasAttribute2: false,
      hasAttribute2Scale: false,
      visible: true,
      color: {
        type: 'colorizer.Value',
        color: 'rgb( 256, 256, 256 )'
      },
      // Colorizer,
      opacity: 1.0,
      attribute: 'name',
      attribute2: null,
      attribute2Scale: 0.8,
      allowOverlap: false,
      ignorePlacement: false
    },
    selectedLineStyle: {
      hasColor: false,
      hasWidth: true,
      hasOpacity: false,
      hasStyle: false,
      hasPattern: false,
      hasDashArray: false,
      hasCap: false,
      hasJoin: false,
      color: null,
      // Colorizer,
      width: 3,
      style: 'default',
      pattern: null,
      dashArray: null,
      // [ 8, 3 ]
      opacity: 0.5,
      cap: 'round',
      join: 'round'
    },
    selectedFillStyle: {
      hasColor: false,
      hasPattern: false,
      hasOpacity: true,
      color: null,
      // Colorizer,
      pattern: null,
      // for image bgs
      opacity: 0.5
    },
    selectedLabelStyle: {
      hasVisible: false,
      hasColor: false,
      hasOpacity: false,
      hasAttribute: false,
      hasAttribute2: false,
      hasAttribute2Scale: false,
      visible: true,
      color: {
        type: 'colorizer.Value',
        color: 'rgb( 256, 256, 256 )'
      },
      // Colorizer,
      opacity: 1.0,
      attribute: 'name',
      attribute2: null,
      attribute2Scale: 0.8,
      allowOverlap: false,
      ignorePlacement: false
    },
    customFilters: {
      includeOutdoorZones: true,
      includeIndoorZonesRPSEnabled: true,
      includeIndoorZonesRPSDisabled: true
    },
    ...extend
  };
}
function update(model, context) {
  const {
    attribute
  } = context;
  if (attribute.displayName !== model.name) {
    return GoogleGeoLayerModel.setName(model, attribute.displayName);
  }
  return model;
}
export default {
  ...GoogleGeoLayerModel,
  TYPE,
  create,
  update,
  ...ModelUtil.createAllValue('lineStyle/color', 'LineColor'),
  ...ModelUtil.createAllValue('lineStyle/width', 'LineWidth'),
  ...ModelUtil.createAllValue('lineStyle/style', 'LineStyle'),
  ...ModelUtil.createAllValue('lineStyle/pattern', 'LinePattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('lineStyle/dashArray', 'LineDashArray', {
    validate: ModelUtil.isNumberArray
  }),
  ...ModelUtil.createAllValue('lineStyle/opacity', 'LineOpacity'),
  ...ModelUtil.createAllValue('lineStyle/cap', 'LineCap'),
  ...ModelUtil.createAllValue('lineStyle/join', 'LineJoin'),
  ...ModelUtil.createAllValue('fillStyle/color', 'FillColor'),
  ...ModelUtil.createAllValue('fillStyle/pattern', 'FillPattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('fillStyle/opacity', 'FillOpacity'),
  ...ModelUtil.createAllValue('labelStyle/visible', 'LabelVisible'),
  ...ModelUtil.createAllValue('labelStyle/opacity', 'LabelOpacity'),
  ...ModelUtil.createAllValue('labelStyle/color', 'LabelColor'),
  ...ModelUtil.createAllValue('labelStyle/size', 'LabelSize'),
  ...ModelUtil.createAllValue('labelStyle/attribute', 'LabelAttribute'),
  ...ModelUtil.createAllValue('labelStyle/attribute2', 'LabelAttribute2'),
  ...ModelUtil.createAllValue('labelStyle/attribute2Scale', 'LabelAttribute2Scale'),
  ...ModelUtil.createAllValue('labelStyle/allowOverlap', 'AllowOverlap'),
  ...ModelUtil.createAllValue('labelStyle/ignorePlacement', 'IgnorePlacement'),
  ...ModelUtil.createAllValue('rolloverLineStyle/color', 'RolloverLineColor'),
  ...ModelUtil.createAllValue('rolloverLineStyle/width', 'RolloverLineWidth'),
  ...ModelUtil.createAllValue('rolloverLineStyle/style', 'RolloverLineStyle'),
  ...ModelUtil.createAllValue('rolloverLineStyle/pattern', 'RolloverLinePattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('rolloverLineStyle/dashArray', 'RolloverLineDashArray'),
  ...ModelUtil.createAllValue('rolloverLineStyle/opacity', 'RolloverLineOpacity'),
  ...ModelUtil.createAllValue('rolloverLineStyle/cap', 'RolloverLineCap'),
  ...ModelUtil.createAllValue('rolloverLineStyle/join', 'RolloverLineJoin'),
  ...ModelUtil.createAllValue('rolloverFillStyle/color', 'RolloverFillColor'),
  ...ModelUtil.createAllValue('rolloverFillStyle/pattern', 'RolloverFillPattern'),
  ...ModelUtil.createAllValue('rolloverFillStyle/opacity', 'RolloverFillOpacity'),
  ...ModelUtil.createAllValue('rolloverLineStyle/hasColor', 'HasRolloverLineColor'),
  ...ModelUtil.createAllValue('rolloverLineStyle/hasWidth', 'HasRolloverLineWidth'),
  ...ModelUtil.createAllValue('rolloverLineStyle/hasStyle', 'HasRolloverLineStyle'),
  ...ModelUtil.createAllValue('rolloverLineStyle/hasOpacity', 'HasRolloverLineOpacity'),
  ...ModelUtil.createAllValue('rolloverLineStyle/hasCap', 'HasRolloverLineCap'),
  ...ModelUtil.createAllValue('rolloverLineStyle/hasJoin', 'HasRolloverLineJoin'),
  ...ModelUtil.createAllValue('rolloverFillStyle/hasColor', 'HasRolloverFillColor'),
  ...ModelUtil.createAllValue('rolloverFillStyle/hasPattern', 'HasRolloverFillPattern'),
  ...ModelUtil.createAllValue('rolloverFillStyle/hasOpacity', 'HasRolloverFillOpacity'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/hasVisible', 'HasRolloverLabelVisible'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/hasOpacity', 'HasRolloverLabelOpacity'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/hasColor', 'HasRolloverLabelColor'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/hasSize', 'HasRolloverLabelSize'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/hasAttribute', 'HasRolloverLabelAttribute'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/hasAttribute2', 'HasRolloverLabelAttribute2'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/hasAttribute2Scale', 'HasRolloverLabelAttribute2Scale'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/visible', 'RolloverLabelVisible'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/opacity', 'RolloverLabelOpacity'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/color', 'RolloverLabelColor'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/size', 'RolloverLabelSize'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/attribute', 'RolloverLabelAttribute'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/attribute2', 'RolloverLabelAttribute2'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/attribute2Scale', 'RolloverLabelAttribute2Scale'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/allowOverlap', 'RolloverAllowOverlap'),
  ...ModelUtil.createAllValue('rolloverLabelStyle/ignorePlacement', 'RolloverIgnorePlacement'),
  ...ModelUtil.createAllValue('selectedLineStyle/color', 'SelectedLineColor'),
  ...ModelUtil.createAllValue('selectedLineStyle/width', 'SelectedLineWidth'),
  ...ModelUtil.createAllValue('selectedLineStyle/style', 'SelectedLineStyle'),
  ...ModelUtil.createAllValue('selectedLineStyle/pattern', 'SelectedLinePattern'),
  ...ModelUtil.createAllValue('selectedLineStyle/dashArray', 'SelectedLineDashArray'),
  ...ModelUtil.createAllValue('selectedLineStyle/opacity', 'SelectedLineOpacity'),
  ...ModelUtil.createAllValue('selectedLineStyle/cap', 'SelectedLineCap'),
  ...ModelUtil.createAllValue('selectedLineStyle/join', 'SelectedLineJoin'),
  ...ModelUtil.createAllValue('selectedFillStyle/color', 'SelectedFillColor'),
  ...ModelUtil.createAllValue('selectedFillStyle/pattern', 'SelectedFillPattern'),
  ...ModelUtil.createAllValue('selectedFillStyle/opacity', 'SelectedFillOpacity'),
  ...ModelUtil.createAllValue('selectedLineStyle/hasColor', 'HasSelectedLineColor'),
  ...ModelUtil.createAllValue('selectedLineStyle/hasWidth', 'HasSelectedLineWidth'),
  ...ModelUtil.createAllValue('selectedLineStyle/hasStyle', 'HasSelectedLineStyle'),
  ...ModelUtil.createAllValue('selectedLineStyle/hasOpacity', 'HasSelectedLineOpacity'),
  ...ModelUtil.createAllValue('selectedLineStyle/hasCap', 'HasSelectedLineCap'),
  ...ModelUtil.createAllValue('selectedLineStyle/hasJoin', 'HasSelectedLineJoin'),
  ...ModelUtil.createAllValue('selectedFillStyle/hasColor', 'HasSelectedFillColor'),
  ...ModelUtil.createAllValue('selectedFillStyle/hasPattern', 'HasSelectedFillPattern'),
  ...ModelUtil.createAllValue('selectedFillStyle/hasOpacity', 'HasSelectedFillOpacity'),
  ...ModelUtil.createAllValue('selectedLabelStyle/hasVisible', 'HasSelectedLabelVisible'),
  ...ModelUtil.createAllValue('selectedLabelStyle/hasOpacity', 'HasSelectedLabelOpacity'),
  ...ModelUtil.createAllValue('selectedLabelStyle/hasColor', 'HasSelectedLabelColor'),
  ...ModelUtil.createAllValue('selectedLabelStyle/hasSize', 'HasSelectedLabelSize'),
  ...ModelUtil.createAllValue('selectedLabelStyle/hasAttribute', 'HasSelectedLabelAttribute'),
  ...ModelUtil.createAllValue('selectedLabelStyle/hasAttribute2', 'HasSelectedLabelAttribute2'),
  ...ModelUtil.createAllValue('selectedLabelStyle/hasAttribute2Scale', 'HasSelectedLabelAttribute2Scale'),
  ...ModelUtil.createAllValue('selectedLabelStyle/visible', 'SelectedLabelVisible'),
  ...ModelUtil.createAllValue('selectedLabelStyle/opacity', 'SelectedLabelOpacity'),
  ...ModelUtil.createAllValue('selectedLabelStyle/color', 'SelectedLabelColor'),
  ...ModelUtil.createAllValue('selectedLabelStyle/size', 'SelectedLabelSize'),
  ...ModelUtil.createAllValue('selectedLabelStyle/attribute', 'SelectedLabelAttribute'),
  ...ModelUtil.createAllValue('selectedLabelStyle/attribute2', 'SelectedLabelAttribute2'),
  ...ModelUtil.createAllValue('selectedLabelStyle/attribute2Scale', 'SelectedLabelAttribute2Scale'),
  ...ModelUtil.createAllValue('selectedLabelStyle/allowOverlap', 'SelectedAllowOverlap'),
  ...ModelUtil.createAllValue('selectedLabelStyle/ignorePlacement', 'SelectedIgnorePlacement'),
  ...ModelUtil.createAllValue('customFilters/includeOutdoorZones', 'IncludeOutdoorZones'),
  ...ModelUtil.createAllValue('customFilters/includeIndoorZonesRPSEnabled', 'IncludeIndoorZonesRPSEnabled'),
  ...ModelUtil.createAllValue('customFilters/includeIndoorZonesRPSDisabled', 'IncludeIndoorZonesRPSDisabled')
};